import { css } from '@emotion/css';

export const appFrameContainer = css`
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const appFrame = css`
  flex: 1;
  height: auto;
  min-height: 0;
`;

export const topBar = css`
  overflow: visible;
`;
